import * as actionTypes from './actionTypes';
import axios from '../../axios-common';
import axiosRequest from '../../axios-request/request.methods';
import * as actions from "./index";

export const fetchAllProposalSuccess = (tracker_res) => {
    return {
        type: actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS,
        allProposal: tracker_res,
    }
}

export const fetchAllProposalStart = () => {
    return {
        type: actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS_START,
    }
}

export const fetchAllProposalFail = (error) => {
    return {
        type: actionTypes.FETCH_ALL_PROPOSAL_AGENT_DETAILS_FAIL,
        error: error,
    }
}

export const getProposalDetails = (proposalId) => {
    return async (dispatch) => {
        dispatch(fetchAllProposalStart());
        try {
            let tracker_res = await axiosRequest.get(`user/getProposal/${proposalId}`);
            if (tracker_res?.errCode !== 256) {
                const data = tracker_res[0];
                dispatch(fetchAllProposalSuccess(data));

                // Update other slices of the store as seen in WIPApplication.js
                if (data?.benefitIllustration) dispatch(actions.fetchBi(data.benefitIllustration));
                if (data?.elinsuranceAccountDetails) dispatch(actions.fetchEinsurance(data.elinsuranceAccountDetails));
                if (data?.FinancialDetails) dispatch(actions.fetchFinancialDetails(data.FinancialDetails));
                if (data?.AboutCustomer) dispatch(actions.fetchAboutCustomer(data.AboutCustomer));
                if (data?.HealthDetailsSection) dispatch(actions.fetchHealthDetails(data.HealthDetailsSection));
                if (data?.PreviousPolicyDetails) dispatch(actions.fetchPreviousPolicyDetails(data.PreviousPolicyDetails));
                if (data?.NominationDetails) dispatch(actions.fetchNominationDetails(data.NominationDetails));
                if (data?.ProposerDetails) dispatch(actions.fetchProposalDetails(data.ProposerDetails));
                if (data?.paymentOptions) dispatch(actions.fetchPayments(data.paymentOptions));
                if (data?.eNachStatus) dispatch(actions.AddENACHDetails(data.eNachStatus));
                if (data?.Declaration) dispatch(actions.fetchDelaration(data.Declaration));

                return data;
            } else {
                dispatch(fetchAllProposalFail("Error fetching proposal data"));
            }
        } catch (error) {
            console.error("Error in getProposalDetails thunk:", error);
            dispatch(fetchAllProposalFail(error.message));
        }
    }
}